var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"config__form_controls",class:{
    'config__form_controls--fixed': _vm.fixed,
    'config__form_controls--offset_left': _vm.offset === 'left',
    'config__form_controls--offset_right': _vm.offset === 'right',
  },style:(_vm.offsetStyling)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }